import React from 'react'
import "./style.css"

function TechAndTools (props){
  return(
    <div class="tech-and-TechAndTools center-column">
    <h2 class="section-title">Tech and Tools</h2>
      <center>  
        <ul>
          <li><img src="https://cdn.svgporn.com/logos/javascript.svg"/></li>
          <li><img src="https://cdn.svgporn.com/logos/react.svg"/></li>
          <li><img src="https://cdn.svgporn.com/logos/css-3.svg"/></li>
          <li><img src="https://cdn.svgporn.com/logos/html-5.svg"/></li>
          <li><img src="https://cdn.svgporn.com/logos/vue.svg"/></li>
          <li><img src="https://cdn.svgporn.com/logos/python.svg"/></li>
          <li><img src="https://cdn.svgporn.com/logos/java.svg"/></li>
          <li><img src="https://cdn.svgporn.com/logos/c-plusplus.svg"/></li>
        </ul>
      </center>
      <br/>
      <br/>
      <center>  
        <ul>
          <li><img src="https://cdn.svgporn.com/logos/vim.svg"/></li>
          <li><img src="https://cdn.svgporn.com/logos/linux-tux.svg"/></li>
          <li><img src="https://cdn.svgporn.com/logos/macOS.svg"/></li>
          <li><img src="https://cdn.svgporn.com/logos/git.svg"/></li>
        </ul>
      </center>
    </div>
  )
}
export default TechAndTools;